export default "__VITE_ASSET__Cn_s0oxl__"